/**
 * Role utility functions
 * Handles conversion between API format and UI display format
 */

export type ApiRole = 'ADMIN' | 'RFP_MANAGER';
export type DisplayRole = 'Admin' | 'Viewer';

/**
 * Convert API role format to human-readable display format
 * @param role - API role (e.g., 'ADMIN', 'RFP_MANAGER')
 * @returns Human-readable role (e.g., 'Admin', 'Viewer')
 */
export function formatRoleForDisplay(role: ApiRole | string): DisplayRole {
    const upperRole = role.toUpperCase();
    if (upperRole === 'ADMIN') {
        return 'Admin';
    } else if (upperRole === 'RFP_MANAGER' || upperRole === 'RFPMANAGER') {
        return 'Viewer';
    }
    // Default fallback
    return 'Viewer';
}

/**
 * Convert display role format to API format
 * @param role - Display role (e.g., 'Admin', 'Viewer')
 * @returns API role (e.g., 'ADMIN', 'RFP_MANAGER')
 */
export function formatRoleForApi(role: DisplayRole | ApiRole | string): ApiRole {
    const normalized = role.toString().toUpperCase().replace(/\s+/g, '_');
    if (normalized === 'ADMIN') {
        return 'ADMIN';
    } else if (normalized === 'RFP_MANAGER' || normalized === 'RFPMANAGER' || normalized === 'VIEWER' || normalized === 'REVIEWER') {
        return 'RFP_MANAGER';
    }
    // Default fallback
    return 'RFP_MANAGER';
}










